import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    createAt?: string;
}

export const UserChatMessage = ({ message, createAt }: Props) => {
    const time = createAt && new Date(createAt).toLocaleTimeString();

    return (
        <div className={styles.container}>
            <div className={styles.message}>{message}</div>
            {time && <span className={styles.time}>{time}</span>}
        </div>
    );
};
